import { defineComponent as _defineComponent } from 'vue'

import { PropType, computed, defineComponent } from "@nuxtjs/composition-api";
import { RawLocation } from "vue-router";

import { useLinkService, useVuetify } from "@/composables";

const __default__ = defineComponent({});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CreatorShopTile',
  props: {
  href: {
    type: String,
    required: false,
    default: "",
  },
  images: {
    type: Array as PropType<string[]>,
    required: true,
  },
  imageSize: {
    type: String,
    required: false,
    default: "",
  },
  maxWidth: {
    type: [String, Number] as PropType<RawLocation>,
    required: false,
    default: 288,
  },
  small: {
    type: Boolean,
    default: true,
  },
  showAudience: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
  subtype: {
    type: String,
    default: "",
  },
  to: {
    type: [String, Object],
    required: false,
    default: "",
  },
  showDiscountPercent: {
    type: Boolean,
    default: false,
  },
  discountPercent: {
    type: Number,
    default: 0,
  },
  width: {
    type: [String, Number],
    required: false,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  experiment: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;


const linkService = useLinkService();
const vuetify = useVuetify();

const imgSize = computed(() => {
  if (props.imageSize) {
    return props.imageSize;
  }
  if (props.small) {
    return vuetify.breakpoint.xsOnly ? "75" : "93";
  }
  return vuetify.breakpoint.smAndDown ? "200" : "345";
});

const isGiftGuide = computed(() => {
  return props.subtype === "GIFT_GUIDE";
});

const imageUrls = computed(() => {
  if (props.images?.length) {
    return props.images.map((imageUrl: string) => {
      return linkService.getImageLink({ url: imageUrl, width: imgSize.value, height: imgSize.value });
    });
  }
  return [];
});

const tileWidth = computed(() => {
  if (props.width) {
    return props.width;
  }

  const SM_WIDTH = 150;
  const MD_WIDTH = 186;
  const XL_WIDTH = 230;
  return vuetify.breakpoint.smAndDown ? SM_WIDTH : vuetify.breakpoint.xlOnly ? XL_WIDTH : MD_WIDTH;
});

return { __sfc: true,props, linkService, vuetify, imgSize, isGiftGuide, imageUrls, tileWidth }
}

})